<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-System-Product-Type-Manage",
  path: "manage",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
